import { type SxProps, type Theme } from "@mui/material";

import { type TextFieldSize } from "ui/text-field/text-field.types";

/** Figma's `input/{size}/container/clear-spacing`: either side of the divider. */
export const ACTION_SPACING: Record<TextFieldSize, number> = { medium: 1, small: 0.75 };

/**
 * Figma's `input/{size}/container/pr`, whatever sits at the end — the actions, `readActions` or an
 * `endIcon`. It replaces the 4px `TextField` tucks `inputActions` to, which is for text buttons, whose own
 * padding pulls the label further in.
 */
export const CONTROL_INSET: Record<TextFieldSize, number> = { medium: 1.25, small: 0.75 };

/** Figma's `input/{size}/divider/height`: 20 at both sizes, so it stands taller than a small field's glyphs. */
export const DIVIDER_HEIGHT = 20;

export const ACTIONS_SX: Record<TextFieldSize, SxProps<Theme>> = {
  medium: { display: "flex", alignItems: "center", gap: ACTION_SPACING.medium },
  small: { display: "flex", alignItems: "center", gap: ACTION_SPACING.small },
};

/** Under `adornedEnd`, so it carries the same two classes as `TextField`'s inset and wins on order. */
export const CONTROL_SX: Record<TextFieldSize, SxProps<Theme>> = {
  medium: { "&.MuiInputBase-adornedEnd": { paddingRight: CONTROL_INSET.medium } },
  small: { "&.MuiInputBase-adornedEnd": { paddingRight: CONTROL_INSET.small } },
};

export const DIVIDER_SX: SxProps<Theme> = { height: DIVIDER_HEIGHT };
